

































































import { RankingActionEnum } from '@empathybroker/tsclient-play/dist/enums/ranking-action.enum';
import { Facet } from '@empathybroker/tsclient-play/dist/models/facet';
import { FacetValue } from '@empathybroker/tsclient-play/dist/models/facet-value';

import { ColorEnum } from '../../enums';

import { capitalizeSentence } from '../../filters';

import Badge from '../badge.component.vue';
import EditableLabel from '../editable-label.component.vue';
import { UiIconButton, UiSelect } from '../keen-ui';
import MutableList from '../mutable-list.component.vue';

export default {
  name: 'facets-configuration-list',
  props: {
    facets: {
      type: Array,
      required: true
    },
    sortTypeOptions: { // { value: string, label: string }[]
      type: Array,
      required: true
    },
    messages: {
      type: Object,
      required: true
    }
  },
  components: {
    MutableList,
    EditableLabel,
    UiSelect,
    Badge,
    UiIconButton
  },
  computed: {
    sortTypeSelectOptions: function (): any[] {
      return this.sortTypeOptions.map(option => ({
        ...option,
        label: capitalizeSentence(`${ this.messages.sortType.inlineLabel } ${ option.label }`)
      }));
    }
  },
  data: function () {
    return {
      editFormValues: {},
      expandedFacetIds: []
    };
  },
  methods: {
    onMoveFacet: function ({ item: facet, targetIndex }): void {
      this.facets.splice(this.facets.indexOf(facet), 1);
      this.facets.splice(targetIndex, 0, facet);
    },
    onEditFacet: function (facet: Facet): void {
      if (!this.isFacetIdEdited(facet.id)) {
        this.editFormValues = {
          id: facet.id,
          prettyName: facet.prettyName,
          sortType: this.getFacetSortTypeOption(facet)
        };
      } else {
        Object.assign(facet, {
          prettyName: this.editFormValues.prettyName,
          sortType: this.editFormValues.sortType.value
        });
        this.editFormValues = {};
      }
    },
    isFacetIdEdited: function (facetId: string): boolean {
      return (facetId === this.editFormValues.id);
    },
    getFacetSortTypeOption: function (facet: Facet): any {
      return this.sortTypeSelectOptions.find(option => (option.value === facet.sortType));
    },
    onExpandFacet: function (facet: Facet): void {
      const indexOfExpandedFacetId = this.expandedFacetIds.indexOf(facet.id);
      if (indexOfExpandedFacetId < 0) {
        this.expandedFacetIds.push(facet.id);
      } else {
        this.expandedFacetIds.splice(indexOfExpandedFacetId, 1);
      }
    },
    onRemoveFacet: function (facet: Facet): void {
      this.facets.splice(this.facets.indexOf(facet), 1);
    },
    getFacetPrettyNameValue: function (facet: Facet): string {
      return (this.isFacetIdEdited(facet.id) ? this.editFormValues.prettyName : capitalizeSentence(facet.prettyName || facet.id));
    },
    getFacetSortTypeValue: function (facet: Facet): string {
      return (this.isFacetIdEdited(facet.id) ? this.editFormValues.sortType : this.getFacetSortTypeOption(facet));
    },
    getSortedFacetValuesByAction: function (facetValues: FacetValue[]): FacetValue[] {
      return [...facetValues].sort((facetValue1: FacetValue, facetValue2: FacetValue) => {
        if (facetValue1.action !== facetValue2.action) {
          return ((facetValue1.action === RankingActionEnum.BOOST) ? -1 : 1);
        }
        return 0;
      });
    },
    getActionColor: function (action: RankingActionEnum): ColorEnum {
      return {
        [RankingActionEnum.BOOST]: ColorEnum.GREEN,
        [RankingActionEnum.BURY]: ColorEnum.RED
      }[action];
    },
    onRemoveFacetValue: function (facet: Facet, facetValue: FacetValue): void {
      facet.values.splice(facet.values.indexOf(facetValue), 1);
    }
  }
};
